import { apiTransformer } from 'utils';

export const associationToApiTransformer = values => {
    const clubs = values['clubs'].map(c => '/api/clubs/' + c);
    return {...apiTransformer(values, ['location']), clubs};
}
